import React from 'react';
import LazyLoad from 'vanilla-lazyload';

const lazyloadConfig = {
  elements_selector: '.lazy',
};

// @ts-ignore
if (!document.lazyLoadInstance) {
  // @ts-ignore
  document.lazyLoadInstance = new LazyLoad(lazyloadConfig);
}

type LazyImageProps = {
  priority?: boolean;
} & Omit<JSX.IntrinsicElements['img'], 'ref'>;

export class LazyImage extends React.Component<LazyImageProps> {
  // Update lazyLoad after first rendering of every image
  componentDidMount() {
    // @ts-ignore
    document.lazyLoadInstance.update();
  }

  // Update lazyLoad after rerendering of every image
  componentDidUpdate() {
    // @ts-ignore
    document.lazyLoadInstance.update();
  }

  // Just render the image with data-src
  render() {
    const { alt, src, srcSet, sizes, width, height, priority = false, ...rest } = this.props;
    return (
      <img
        key={src}
        decoding="async"
        alt={alt}
        {...(priority
          ? {
              src,
              srcSet,
              sizes,
              fetchpriority: 'high',
            }
          : {
              'data-src': src,
              'data-srcset': srcSet,
              'data-sizes': sizes,
              className: 'lazy',
            })}
        width={width}
        height={height}
        {...rest}
      />
    );
  }
}

export default LazyImage;
